import React from 'react';
import Spinner from 'react-spinkit';

import './spinner_fallback.scss';

const CLASS_NAME = 'spinner-fallback';

const SpinnerFallback = () => (
  <div className={CLASS_NAME}>
    <Spinner name="three-bounce" className="bw-spinner" fadeIn="none" />
  </div>
);

export default SpinnerFallback;
